import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { RegionEffects } from './regions.effects';
import { RegionNamespace, RegionReducer } from './regions.store';

@NgModule({
  imports: [
    StoreModule.forFeature(RegionNamespace, RegionReducer),
    EffectsModule.forFeature([RegionEffects]),
  ],
})
export class RegionsDataModule {}
